import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=fd6627a6&scoped=true&"
import script from "./ScrollToTop.vue?vue&type=script&lang=js&"
export * from "./ScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/ScrollToTop/ScrollToTop.less?vue&type=style&index=0&id=fd6627a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6627a6",
  null
  
)

export default component.exports